import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { NotFoundComponent } from '../../components/not-found/not-found.component';
import { LoginComponent } from '../../components/auth/login/login.component';
import { AuthGuard } from '../../guards/auth.guard';
import { NotAuthorizedComponent } from '../../components/not-authorized/not-authorized.component';
import { RoleGuard } from '../../guards/role.guard';
// import { InMaintenanceComponent } from 'src/app/components/in-maintenance/in-maintenance.component';

const routes: Routes = [
	/* {
    path: 'in-maintenance',
    component: InMaintenanceComponent
  },
  {
    path: '**',
    redirectTo: '/in-maintenance',
    pathMatch: 'full',
  },*/
	{
		path: '',
		redirectTo: '/dashboard/home',
		// redirectTo: '/in-maintenance',
		pathMatch: 'full',
	},
	{
		path: '',
		component: LayoutComponent,
		children: [
			{
				path: 'dashboard',
				loadChildren: () =>
					import('../../modules/dashboard/dashboard.module').then(
						(m) => m.DashboardModule,
					),
				data: {
					breadcrumb: 'Dashboard',
					isModule: true,
				},
			},
			{
				path: 'ayudas',
				loadChildren: () =>
					import('../../modules/ayudas/ayudas.module').then(
						(m) => m.AyudasModule,
					),
				data: {
					breadcrumb: 'Ayudas',
					isModule: true,
				},
			},
			{
				path: 'documentos',
				loadChildren: () =>
					import('../../modules/documentos/documentos.module').then(
						(m) => m.DocumentosModule,
					),
				data: {
					breadcrumb: 'Documentos',
					moduleName: 'documents',
					isModule: true,
				},
				canActivate: [RoleGuard],
				canLoad: [RoleGuard],
			},
			{
				path: 'recursos',
				loadChildren: () =>
					import('../../modules/recursos/recursos.module').then(
						(m) => m.RecursosModule,
					),
				data: {
					breadcrumb: 'Recursos',
					moduleName: 'resources',
					isModule: true,
				},
				canActivate: [RoleGuard],
				canLoad: [RoleGuard],
			},
			{
				path: 'instituciones',
				loadChildren: () =>
					import('../../modules/instituciones/instituciones.module').then(
						(m) => m.InstitucionesModule,
					),
				data: {
					breadcrumb: 'Instituciones',
					moduleName: 'institutions',
					isModule: true,
				},
				canActivate: [RoleGuard],
				canLoad: [RoleGuard],
			},
			{
				path: 'usuarios',
				loadChildren: () =>
					import('../../modules/usuarios/usuarios.module').then(
						(m) => m.UsuariosModule,
					),
				data: {
					breadcrumb: 'Usuarios',
					moduleName: 'users',
					isModule: true,
				},
				canActivate: [RoleGuard],
				canLoad: [RoleGuard],
			},
			{
				path: 'ruta',
				loadChildren: () =>
					import('../../modules/ruta/ruta.module').then((m) => m.RutaModule),
				data: {
					breadcrumb: 'Ruta de mejoramiento',
					disableLink: true,
					moduleName: 'route',
					isModule: true,
				},
				canActivate: [RoleGuard],
				canLoad: [RoleGuard],
			},
			{
				path: 'hoja-vida-institucional',
				loadChildren: () =>
					import(
						'../../modules/institutional-resume/institutional-resume.module'
					).then((m) => m.InstitutionalResumeModule),
				data: {
					breadcrumb: 'Hoja de vida institucional',
					moduleName: 'institutional-resume',
					isModule: true,
				},
				canActivate: [RoleGuard],
				canLoad: [RoleGuard],
			},
			{
				path: 'perfil',
				loadChildren: () =>
					import('../../modules/perfil/perfil.module').then(
						(m) => m.PerfilModule,
					),
				data: {
					breadcrumb: 'Perfil',
				},
			},
			{
				path: 'proyectos',
				loadChildren: () =>
					import(
						'../../modules/recursos/components/proyectos/proyectos.module'
					).then((m) => m.ProyectosModule),
				data: {
					breadcrumb: 'Proyectos',
					moduleName: 'projects',
					isModule: true,
				},
				canActivate: [RoleGuard],
				canLoad: [RoleGuard],
			},
			{
				path: 'servicios',
				loadChildren: () =>
					import('../../modules/servicios/servicios.module').then(
						(m) => m.ServiciosModule,
					),
				data: {
					breadcrumb: 'Servicios',
					moduleName: 'servicios',
					isModule: true,
				},
				canActivate: [RoleGuard],
				canLoad: [RoleGuard],
			},
		],
		canActivate: [AuthGuard],
		canLoad: [AuthGuard],
	},
	{
		path: 'login',
		component: LoginComponent,
	},
	{
		path: 'not-found',
		component: NotFoundComponent,
	},
	{
		path: 'not-authorized',
		component: NotAuthorizedComponent,
	},
	{
		path: '**',
		redirectTo: 'not-found',
		pathMatch: 'full',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class LayoutRoutingModule {}
